import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import StaticSearch from '../../search/StaticSearch';

export default function FormInputStaticSearch(props) {
  const searchProps = {
    allowSelectAll: false,
    filterBy: 'value',
    showAll: true,
    sortBy: 'name',
    suggestions: props.search.suggestions, // eslint-disable-line
  };

  return <FormInputSearch {...props} searchComponent={StaticSearch} searchProps={searchProps} />;
}
